import React, {ReactElement, useEffect, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogHeader, useId} from "@salt-ds/core";
interface SessionWarningDialogProps{
    onContinue:()=> void;
    onTimeout:()=> void;
}

export const  SessionWarningDialog= ({onContinue, onTimeout}:SessionWarningDialogProps): ReactElement =>{
    const[open, setOpen]= useState(true)
    const [countdown, setCountDown]= useState(23);
    const id = useId();

    const handleContinue= ()=>{
        setOpen(false);
        onContinue();
    };

    useEffect(() => {
       const timer = setInterval(()=>{
           setCountDown((prev)=>{
               if (prev<=1){
                   clearInterval(timer);
                   setOpen(false);
                   onTimeout();
                   return 0;
               }
               return prev - 1;
           });
           return ()=> clearInterval(timer)
       }, 1000)
    }, [onTimeout]);

    return (
        <Dialog open={open}  status="warning" size="small" id={id}  className="w-[560px]" >
            <DialogHeader header="Session Timeout" />
            <DialogContent >
                Your session will be time out in <span className="text-customBlue">{countdown}</span> seconds, any enrollment information entered will be lost.
                Click “Continue Enrollment” to extend your session.            </DialogContent>
            <DialogActions>

                <Button variant="cta"
                        onClick={handleContinue}

                        className="text-right normal-case text-white text-sm font-medium font-['Amplitude'] leading-[18px] h-8 px-2 py-[7px]
                        rounded border border-cyan-700 justify-center items-center gap-1 inline-flex "
                >
                    Continue Enrollment
                </Button>

            </DialogActions>
        </Dialog>

    )

}